import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { DeliveryAddressService } from '@checkout-v2/feature';
import { SdModalService, SdvorButtonComponent, SdvorIconComponent } from '@sdvor/shared/ui/v2';
import { IconTypes } from '@shared/v2';
import { DeliveryAddressDialogComponent } from '../delivery-address-dialog';
@Component({
  selector: 'sd-delivery-add-address',
  imports: [SdvorButtonComponent, SdvorIconComponent],
  templateUrl: './delivery-add-address.component.html',
  styleUrls: ['./delivery-add-address.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeliveryAddAddressComponent {
  protected readonly text = input<string>('выбрать адрес');
  protected readonly iconTypes = IconTypes;

  private readonly modalService = inject(SdModalService);
  private readonly deliveryAddressService = inject(DeliveryAddressService);

  openModal(): void {
    this.deliveryAddressService.editableAddressId$.next(undefined);

    this.modalService.open(DeliveryAddressDialogComponent, {
      modalType: { xxs: 'fullscreen', lg: 'standard' },
      maxWidth: { lg: '1240px' },
    });
  }
}
